import { HttpHelpService } from './../../Data/service/http-help.service';
import { Component, OnInit } from "@angular/core";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Auth/service/auth.service';
import { LanguageService } from 'src/app/shared/services/language.service';

@Component({
  selector: "app-navigathion",
  templateUrl: "./navigathion.component.html",
  styleUrls: ["./navigathion.component.scss"]
})

export class NavigathionComponent implements OnInit {
  isNavbarCollapsed = true;
  isLogin : boolean = true ;
  curentLang:string="";
  constructor(
  private service:HttpHelpService ,
   public translate:TranslateService ,
   private _AuthService:AuthService ,   private router: Router,
   private languageService: LanguageService,
   )
   { 
    this.curentLang = localStorage.getItem('curentLang') || 'en';
  }

  changeLanguage(lang: string) {
    this.languageService.apply(lang, { refreshRoute: true });
    this.curentLang = lang;
}
  toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  };
  ngOnInit() {
    this._AuthService.isLogin.next(false)

  };
};
